import { SpecificationConfigurationItem, SpecificationsLibrary } from '@grandvisionhq/fun-products'

export const commonSpecifications: SpecificationConfigurationItem[] = [
  SpecificationsLibrary.lensColor,
  SpecificationsLibrary.frameColor,
  SpecificationsLibrary.frameMaterial,
  SpecificationsLibrary.frameShape,
  SpecificationsLibrary.frameType,
  SpecificationsLibrary.gender,
  SpecificationsLibrary.roadworthiness,
]
